import React, { useEffect, useState, useContext } from 'react'
import { HeaderTitle, Loading, NotifyContext, TabButton, UserProfileImage } from '../Library'
import { viewBuilding, editBuilding, listPackages } from '../Network/Administration'
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import "./BuildingDetail.css"
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faUsers, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { baseURL } from '../Network/Config'
import Resizer from 'react-image-file-resizer'

function BuildingDetail() {
    const { id } = useParams()
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const [isLoading, setLoading] = useState(false)
    const [title, setTitle] = useState("")
    const [buildingData, setBuildingData] = useState(null)
    const [companyData, setCompanyData] = useState([])
    const [userData, setUserData] = useState([])

    const [newBuildingName, setNewBuildingName] = useState("")
    const [newAddress, setNewAddress] = useState("")
    const [newLogo, setNewLogo] = useState(null)

    const [selectMenu, setSelectMenu] = useState(0)
    const [packageList, setPackageList] = useState([])
    const [selectPackage, setSelectPackage] = useState("")
    const [isError, setError] = useState(false)

    const fetchData = () =>{
        setLoading(true)
        listPackages(
            (data)=>{
                setPackageList(data)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            }
        )
        viewBuilding(id,
            (building, company, users)=>{
                setTitle(building.buildingName)
                setBuildingData(building)
                setCompanyData(company)
                setUserData(users)

                setNewBuildingName(building.buildingName)
                setNewAddress(building.address)
                setSelectPackage(building?.packageId || "")
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    }

    const updateBuildingInfo = () =>{
        if(!newBuildingName || !newAddress || !selectPackage){
            setError(true)
            return
        }

        setLoading(true)
        editBuilding(id, newBuildingName, newAddress, selectPackage, newLogo, 
            ()=>{
                notify.showNotify(lang.edited_building_info, lang.edited_building_info_desc, 0)
                setLoading(false)
                setNewLogo(null)
                fetchData()
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="building-detail">
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={title} isShowBack backTo="/buildings"/>
            <Row>
                <Col lg={6}>
                    <div className="detail-col">
                        { buildingData?.buildingLogo !== null ?
                        <div className="building-logo">
                            <img src={baseURL + buildingData?.buildingLogo}/>
                        </div>
                        : null
                        }
                        <DetailRow title={lang.building_name} value={buildingData?.buildingName}/>
                        <DetailRow title={lang.address} value={buildingData?.address}/>
                        <DetailRow title={lang.register_date} value={dayjs(buildingData?.createdDate).format("D MMMM YYYY H:mm")}/>
                        <DetailRow title={lang.no_company} value={companyData.length.toLocaleString() || 0}/>
                        <DetailRow title={lang.no_people} value={userData.length.toLocaleString() || 0}/>
                    </div>
                    <div className="detail-col">
                        <div className="item-title">{lang.edit_building}</div>
                        <Form
                        onSubmit={(e)=>{
                            e.preventDefault()
                            updateBuildingInfo()
                        }}
                        >
                            <Form.Group>
                                <Form.Label>{lang.building_name}</Form.Label>
                                <Form.Control
                                value={newBuildingName}
                                onChange={(e)=>setNewBuildingName(e.target.value)}
                                isInvalid={isError && !newBuildingName}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.address}</Form.Label>
                                <Form.Control
                                as="textarea"
                                value={newAddress}
                                onChange={(e)=>setNewAddress(e.target.value)}
                                isInvalid={isError && !newAddress}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.packages}</Form.Label>
                                <Form.Control 
                                onChange={(e)=>setSelectPackage(e.target.value)}
                                value={selectPackage}
                                isInvalid={isError && !selectPackage}
                                as="select">
                                    <option value="">{lang.choose_package}</option>
                                    { packageList.map((item, key) => 
                                    <option value={item.id} key={key}>{item.packageName}</option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.upload_new_logo}</Form.Label>
                                <Form.File
                                accept="image/*"
                                onChange={(e)=>{
                                    let toUpload = e.target.files[0]
                                    Resizer.imageFileResizer(
                                        toUpload,
                                        150,
                                        150,
                                        "PNG",
                                        100,
                                        0,
                                        (uri)=>{
                                            setNewLogo(uri)
                                        },
                                        "file",
                                        null,
                                        null
                                    )
                                }}
                                />
                                <div style={{ color: 'orange' }}>
                                    {"*" + lang.png_only}
                                </div>
                            </Form.Group>
                            <hr/>
                            <div>
                                <Button type="submit">
                                    {lang.save_change}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className="detail-col">
                        <div className="select-menu-container">
                            <TabButton 
                            title={lang.company} icon={faBuilding} isSelected={selectMenu === 0}
                            onClick={()=>setSelectMenu(0)}/>
                            <TabButton title={lang.users} icon={faUsers} isSelected={selectMenu === 1}
                            onClick={()=>setSelectMenu(1)}/>
                        </div>
                        { selectMenu === 0 ?
                        <div className="content-list-container">
                            { companyData.map((item, key) =>
                            <CompanyItem
                            key={key}
                            name={item.name}
                            location={item.location}
                            />
                            )}
                        </div>
                        : null
                        }
                        { selectMenu === 1 ?
                        <div className="content-list-container">
                            { userData.map((item, key) =>
                            <UserItem
                            key={key}
                            name={item.firstName + " " + item.lastName}
                            email={item.email}
                            profilePicture={item.profileImagePath}
                            position={item.position}
                            />
                            )}
                        </div>
                        : null
                        }
                    </div>
                </Col>
            </Row>
        </div>
    )
}

function DetailRow({ title, value, onClick }){
    return(
        <div className="detail-row" onClick={onClick}>
            <div className="detail-title">{title}:</div>
            <div className="detail-val">{value}</div>
        </div>
    )
}

function CompanyItem({ name, location }){
    return(
        <div className="company-item">
            <div className="icon">
                <FontAwesomeIcon icon={faBuilding}/>
            </div>
            <div>
                <div className="title">{name}</div>
                <div className="desc">{location}</div>
            </div>
        </div>
    )
}

function UserItem({ name, position, email, profilePicture }){
    return(
        <div className="user-item">
            {/* { profilePicture !== "" && profilePicture !== null ?
            <div className="profile-pic">
                <img src={profilePicture} alt={name}/>
            </div>
            :
            <div className="def-profile-pic">
                <FontAwesomeIcon icon={faUserCircle}/>
            </div>
            } */}
            <UserProfileImage
            profileImagePath={profilePicture}
            width={45}
            height={45}
            />
            <div style={{ marginLeft: 13 }}>
                <div className="title">{name}</div>
                <div className="desc">{email}</div>
                <div className="desc">{position}</div>
            </div>
        </div>
    )
}

export default BuildingDetail
